// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e0c65453","977":"809b5e22"}[chunkId] + ".chunk.js";
};